import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { NotFoundRedirect } from "@/components/common/not-found-redirect/not-found-redirect";

export const router = createRouter({
  routeTree,
  // Redirect any unmatched route to the projects home. Primarily this rescues old
  // iOS PWA installs that cold-launch the legacy "/projects" start_url. See
  // not-found-redirect.spec.md.
  defaultNotFoundComponent: NotFoundRedirect,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
